/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import { components, default as ReactSelect } from 'react-select';
import makeAnimated from 'react-select/animated';
import styles from './styles.scoped.css';
import IconUpDownArrow from '../../icons/IconUpDownArrow';

export const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          checked={props.isSelected}
          onChange={() => null}
          type="checkbox"
        />{' '}
        <label className={styles['select-label']}>{props.label}</label>
      </components.Option>
    </div>
  );
};

const MySelect = (props) => {
  // eslint-disable-next-line no-nested-ternary
  const baseOptions = Array.isArray(props.options)
    ? props.options
    : (props.options ? [props.options] : []);
  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        onChange={(selected, event) => {
          if (selected !== null && selected.length > 1) {
            if (selected[selected.length - 1].value === props.allOption.value) {
              return props.onChange([props.allOption, ...baseOptions]);
            }
            let result = [];
            if (selected.length === baseOptions.length) {
              if (selected.includes(props.allOption)) {
                result = selected.filter(
                  (option) => option.value !== props.allOption.value
                );
              } else if (event && event.action === 'select-option') {
                result = [props.allOption, ...baseOptions];
              }
              return props.onChange(result);
            }
          }

          return props.onChange(selected);
        }}
        options={[props.allOption, ...baseOptions]}
      />
    );
  }

  return <ReactSelect {...props} />;
};
MySelect.displayName = 'MySelect';

const allOption = {
  label: 'Select all',
  value: '*',
};

const ValueContainer = ({ children, ...props }) => {
  const currentValues = props.getValue();
  let toBeRendered = children;
  if (currentValues.some((val) => val.value === allOption.value)) {
    toBeRendered = [[children[0][0]], children[1]];
  }

  return (
    <components.ValueContainer {...props}>
      {toBeRendered}
    </components.ValueContainer>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <IconUpDownArrow type={'small'} />
    </components.DropdownIndicator>
  );
};
const animatedComponents = makeAnimated();

function MultiSelectCheckbox({
  handleChange,
  optionSelected,
  data,
  inputProps,
  label,
  handleOnKeyUp,
}) {
  const onChange = (e) => {
    handleChange(inputProps.name, e);
  };

  const onKeyUp = (e) => {
    handleOnKeyUp(inputProps.name, e);
  };

  return (
    <>
      <label>{label}</label>
      <div className={styles.App} onKeyUp={onKeyUp}>
        <MySelect
          {...inputProps}
          allOption={{ label: `Semua ${label}`, value: '*' }}
          allowSelectAll={true}
          closeMenuOnSelect={false}
          components={{
            Option,
            ValueContainer,
            animatedComponents,
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
          hideSelectedOptions={false}
          isMulti
          label={label}
          onChange={onChange}
          options={data}
          theme={(theme) => ({
            ...theme,
            borderRadius: 3,
            border: 0,
          })}
          value={optionSelected}
        />
      </div>
    </>
  );
}

MultiSelectCheckbox.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  handleChange: PropTypes.func,
  handleOnKeyUp: PropTypes.func,
  inputProps: PropTypes.object,
  label: PropTypes.string,
  optionSelected: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

MySelect.propTypes = {
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  allowSelectAll: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.array,
};

Option.propTypes = {
  isSelected: PropTypes.bool,
  label: PropTypes.string,
};

MultiSelectCheckbox.defaultProps = {
  data: [],
  handleChange: () => {},
  inputProps: { name: '' },
  label: '',
  handleOnKeyUp: () => {},
  optionSelected: [],
};

export default MultiSelectCheckbox;
